// extracted by mini-css-extract-plugin
module.exports = {"Containment":"Containment_Containment__sLPQ2","fade":"Containment_fade__3T0q1","StateSection":"Containment_StateSection__12VhL"};